import { useGetGamesQuery } from "../../reducers/apiSlice";
import LightboxSurface from "../../components/lightbox/LightboxSurface";
import styles from "./AdminGames.module.scss";
import { Link } from "react-router-dom";

type Player = {
  objectId: string;
};

type Mystery = {
  name: string;
};

type Game = {
  objectId: string;
  name: string;
  game_state: string;
  current_round: number;
  mystery?: Mystery;
  players?: Player[];
};

const AdminGames = () => {
  const { data, isLoading, isFetching, isError, error } = useGetGamesQuery(undefined);
  const games = (data ?? []) as Game[];

  if (isLoading || isFetching) {
    return <div className={styles.page}><p className={styles.status} role="status">Loading games…</p></div>;
  }

  if (isError) {
    const message =
      typeof error === "object" && error !== null && "status" in error
        ? `Request failed (${String(error.status)}).`
        : "Failed to load games.";

    return <div className={styles.page}><p className={styles.status} role="alert">{message}</p></div>;
  }

  return (
    <section className={styles.page}>
      <h1 className={styles.title}>Admin Games</h1>

      {games.length === 0 ? (
        <p className={styles.status}>No games found.</p>
      ) : (
        <div className={styles.tableWrap}>
          <table className={styles.table}>
            <thead>
              <tr>
                <th>Name</th>
                <th>ID</th>
                <th>State</th>
                <th>Round</th>
                <th>Mystery</th>
                <th>Players</th>
              </tr>
            </thead>
            <tbody>
              {games.map((game) => (
                <tr key={game.objectId}>
                  <td>{game.name}</td>
                  <td><Link to={`/game/${game.objectId}`}>{game.objectId}</Link></td>
                  <td>{game.game_state}</td>
                  <td>{game.current_round ?? 0}</td>
                  <td>{game.mystery?.name ?? "-"}</td>
                  <td>{game.players?.length ?? 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </section>
  );
};

/* UI-DESIGN: all admin states share the same room as player-facing pages. */
const AdminGamesPage = () => <LightboxSurface mode="static" onUnavailable={() => {}}><AdminGames /></LightboxSurface>;
export default AdminGamesPage;
